import React from 'react'
import { Hourglass } from 'lucide-react'
import { money, fmtDay } from '../financial/formatting'

// Value earned after the advance was paid off and before anyone agreed what
// happens to it. Its own card, apart from the KPIs, and deliberately with no
// split or share in it: there are no terms for this money yet, so the screen
// must not suggest any.
export default function PendingTermsCard({ block }) {
  const since = fmtDay(String(block.since).slice(0, 10))
  return (
    <section className="card" aria-label="Pending new terms" style={{
      padding: 18, display: 'flex', flexDirection: 'column', gap: 12,
      borderLeft: '3px solid var(--text-muted)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Hourglass size={16} style={{ color: 'var(--text-muted)' }} />
        <h2 style={{
          margin: 0, fontSize: 12, fontWeight: 700, letterSpacing: 0.6,
          color: 'var(--text-muted)', textTransform: 'uppercase',
        }}>
          Pending new terms
        </h2>
      </div>
      <div className="pd-split" style={{ display: 'flex', gap: 28, flexWrap: 'wrap' }}>
        <Figure label="In this period" value={money(block.in_range)} />
        <Figure label="Total held" value={money(block.total)} />
      </div>
      <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: 'var(--text-secondary)' }}>
        Balance cleared. Value since {since} is held until new terms are agreed.
      </p>
    </section>
  )
}

function Figure({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600 }}>{label}</div>
      <div style={{ fontFamily: 'ui-monospace, monospace', fontSize: 20, fontWeight: 800, color: 'var(--text-primary)' }}>
        {value}
      </div>
    </div>
  )
}
